import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RoleSlugEnum } from 'src/app/enums/role-slug.enum';
import { EmployeeService } from 'src/app/services/employee.service';
import { UserService } from 'src/app/services/user.service';

export type UserProfilePictureSource = {
  pokemon_profile_picture_url?: string | null;
  serious_profile_picture_url?: string | null;
};

const DEFAULT_PROFILE_PICTURE = 'assets/img/default_profile_picture.png';

export function resolveUserProfilePictureUrl(
  displayed_user: UserProfilePictureSource | null | undefined,
  viewer_role_slug: string | null | undefined,
  meeting_mode_enabled: boolean
): string {
  if (displayed_user == null) {
    return DEFAULT_PROFILE_PICTURE;
  }

  const should_use_serious = viewer_role_slug === RoleSlugEnum.PARTNER || viewer_role_slug === RoleSlugEnum.CLIENT || meeting_mode_enabled;

  const url = should_use_serious ? displayed_user.serious_profile_picture_url : displayed_user.pokemon_profile_picture_url;

  return url || DEFAULT_PROFILE_PICTURE;
}

@Component({
  selector: 'app-user-profile-picture',
  templateUrl: './user-profile-picture.component.html',
  styleUrl: './user-profile-picture.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfilePictureComponent {
  private readonly user_service = inject(UserService);
  private readonly employee_service = inject(EmployeeService);

  readonly user = input.required<UserProfilePictureSource | null | undefined>();
  /** Si se omite, el tamaño lo define el CSS del padre. */
  readonly size = input<number | null>(null);
  readonly alt = input<string>('');
  readonly css_class = input<string>('');
  readonly border_color = input<string | null>(null);

  private readonly current_user = toSignal(this.user_service.currentUser, { initialValue: null });
  private readonly meeting_mode_enabled = toSignal(this.employee_service.meetingModeEnabled, { initialValue: false });

  readonly image_url = computed((): string => {
    const viewer = this.current_user();
    return resolveUserProfilePictureUrl(this.user(), viewer?.role?.slug, this.meeting_mode_enabled());
  });
}
